import React from 'react';
import Button from '../../../../../../components/Button';
import { openNewWindow, reDirectPage, setDetailPageUrl } from '../../../../../../lib/common';
import { EVENT_EDIT_URL_PATH } from '../../../../../../constants/service/common/urlConstants';
import Anchor from '../../../../../../components/link/Anchor';
import TableColumnImg from '../../../../../../components/table/TableColumnImg';
import { setDateFormat } from '../../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import { Columns } from '../../../../../../types/common/table';
import { EVENT_STATUS_V2 } from '../../../../../../types/event';
import { EVENT_STATUS_LABEL_V2 } from '../../../../../../constants/service/app/eventConstantsV2';
import { EventItemWithPeriod } from './EventWidgetListTable';
import EventProductListViewButton from './EventProductListViewButton';

const eventColumns: Columns<EventItemWithPeriod, object> = () => {
  return [
    {
      Header: '노출 순서',
      fixed: 'left',
      width: 100,
      Cell: (row) => row.index + 1,
    },
    {
      Header: '수정',
      fixed: 'left',
      width: 100,
      Cell: (row) =>
        row.original.id ? (
          <Button
            isRadius
            color="primary"
            text="수정"
            type="button"
            onClick={async () => {
              reDirectPage({
                path: setDetailPageUrl(EVENT_EDIT_URL_PATH, row.original.id),
              });
            }}
          />
        ) : (
          '-'
        ),
    },
    {
      Header: '상품 보기',
      fixed: 'left',
      width: 100,
      Cell: (row) => (row.original.id ? <EventProductListViewButton eventId={row.original.id} /> : '-'),
    },
    {
      accessor: 'id',
      Header: '기획전 ID',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(EVENT_EDIT_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'status',
      Header: '상태',
      fixed: 'left',
      width: 100,
      Cell: (row) => EVENT_STATUS_LABEL_V2[row.value as EVENT_STATUS_V2],
    },
    {
      accessor: 'url',
      Header: '이미지',
      fixed: 'left',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'mainTitle',
      Header: '제목',
      resizable: true,
      Cell: (row) => <span>{row.value}</span>,
    },
    {
      accessor: 'eventPeriod',
      Header: '기획전 기간',
      width: 320,
      Cell: (row) =>
        row.original.id
          ? row.original.status === EVENT_STATUS_V2.UNLIMITED
            ? EVENT_STATUS_LABEL_V2[row.original.status as EVENT_STATUS_V2]
            : `${setDateFormat(row.original.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} - ${setDateFormat(
                row.original.endDate,
                DATE_FORMAT.FULL_DASH_FORMAT,
              )} `
          : '-',
    },
    {
      accessor: 'exposurePeriod',
      Header: '기획전 노출 기간',
      width: 320,
      Cell: (row) =>
        row.original.id
          ? `${setDateFormat(row.value.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} - ${setDateFormat(
              row.value.endDate,
              DATE_FORMAT.FULL_DASH_FORMAT,
            )} `
          : '-',
    },
  ];
};

export default eventColumns;
